const addCepMask = (cep) => {
  const formattedCep = `${cep.slice(0, 2)}.${cep.slice(2, 5)}-${cep.slice(5)}`;
  return formattedCep;
};

export default addCepMask;
